<script>
    export default {

        data() {
            return {
                table: new Table({
                    anomalies: {}
                })
            }
        },

        created() {
            axios.get('/qms/anomalies')
                .then(({data}) => this.table.anomalies = data)
        }

    }
</script>

<style scoped>

</style>